// extracted by mini-css-extract-plugin
export default {"modalWrapper":"reviews_modalWrapper__+ulck","overlay":"reviews_overlay__PCil-","animationBlock":"reviews_animationBlock__lk0Yk","closeIcon":"reviews_closeIcon__F6AhK"};